import type { ReactNode } from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { Spinner } from "pymble-ui/components";
import { useAutoSignInStatus } from "../hooks/useAutoSignInStatus";
import SignInCard from "./SignInCard";

export default function AuthenticationGate({
  children,
}: {
  children: ReactNode;
}) {
  const status = useAutoSignInStatus();
  const showManualSignIn = status === "failed" || status === "skipped";

  return (
    <>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        {showManualSignIn ? (
          <SignInCard />
        ) : (
          <Spinner
            message={
              status === "attempting"
                ? "Signing you in..."
                : "Checking sign-in..."
            }
          />
        )}
      </UnauthenticatedTemplate>
    </>
  );
}
